import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@dexio/common';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private readonly configs: AppConfigService, private readonly http: HttpClient) { }

  getProjectResults(projects: Array<string>) {
    return this.http.get(`${this.configs.get().apiUrl}/reports/users/stats?projects=${projects.join(',')}`);
    //;, { observe: 'response', responseType: 'blob' }
  }
}
